const DNCACONTACTUSAPIS = "dnca-contactus-apis";

export const COMPANY_FETCH_URL = `${DNCACONTACTUSAPIS}/v1/dnca/prospect-lookup/fetch`;
export const COMPANY_DUNS_SEARCH_URL = `${DNCACONTACTUSAPIS}/v1/dnca/prospect-lookup/duns_search`;
export const SAVE_LEAD_URL = `${DNCACONTACTUSAPIS}/v1/dnca/contact-us/eppublic/save`;
export const GET_LEAD_DATA_URL = `${DNCACONTACTUSAPIS}/v1/dnca/contact-us/eppublic/retrieve`;
export const GET_LEAD_ADMIN_SCORE = `${DNCACONTACTUSAPIS}/v1/dnca/web-lead/LeadScoreStructure`;
export const GET_LEAD_LIST = `${DNCACONTACTUSAPIS}/v1/dnca/web-lead/LeadList`;
export const POST_LEAD_LIST = `${DNCACONTACTUSAPIS}/v1/dnca/web-lead/LeadListScore`;
export const POST_LEAD_LIST_BY_LEADID = `${DNCACONTACTUSAPIS}/v1/dnca/web-lead/regenerateRequestInSF/`;
